const BASE_URL = process.env.REACT_APP_BASE_URL;
const LocalHost = process.env.REACT_APP_LOCAL_HOST;

export const fetchCustomers = async (search) => {
    try {
        const response = await fetch(`${BASE_URL}/api/IndiaPestControl/get-customers?search=${search}`);
        if (!response.ok) {
        throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching customers:', error);
        throw error;
    }
}

export const fetchPestTypes = async () => {
    try {
        const response = await fetch(`${BASE_URL}/api/IndiaPestControl/pest-services`);
        if (!response.ok) {
        throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching customers:', error);
        throw error;
    }
}

export const createInvoice = async (invoiceData) => {
    try {
        const response = await fetch(`${BASE_URL}/api/IndiaPestControl/invoice`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(invoiceData),
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const text = await response.text();
        if (!text) return {};
        try {
            return JSON.parse(text);
        } catch (e) {
            return { message: text };
        }
    } catch (error) {
        console.error('Error creating invoice:', error);
        throw error;
    }
}

